/**
 * motion (string): The VIM motion command (e.g., "w", "3j").
 * explanation (string): Explanation of what the motion does.
 */
export class MotionEntity {
  /**
   * motion (string): The VIM motion command (e.g., "w", "3j").
   */
  motion: string;
  /**
   * explanation (string): Explanation of what the motion does.
   *
   */
  explanation: string;

  constructor(motion: string, explanation: string) {
    this.motion = motion;
    this.explanation = explanation;
  }
}
